<template>
  <button
    type="button"
    class="btn border-0 btnImg"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <img class="imgBottomleft" :src="imgURL" />
    <span v-show="notLink" class="align-middle" :style="'color:' + color">{{
      buttonName
    }}</span>
    <a v-show="!notLink" class="align-middle">{{ buttonName }}</a>
  </button>
</template>

<script>
export default {
  name: 'ButtonImg',
  props: {
    buttonName: String,
    disabled: Boolean,
    imgURL: String,
    notLink: Boolean,
    color: String
  }
}
</script>

<style scoped lang="scss">
.btnImg {
  height: 25px;
  padding: 0 1em;
  font-size: 14px;
}
.btnImg:hover {
  filter: opacity(70%);
}
.btnImg:disabled {
  color: rgb(154, 154, 154);
  border-radius: 4px;
}
</style>
